// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1sUe9","inputDescription":"styles_inputDescription__3gsyP"};